module.exports = __webpack_public_path__ + "static/media/Opening Presents.358d4909.jpg";